import {PARTNER_LOGO_MAP} from '../constants/partnerLogoMap';
import {PartnerLogoConfig} from '../constants/types';
import {GetPartnerLogoParams} from './types';

export function getPartnerLogo({
	cdParceiroLogo,
}: GetPartnerLogoParams): PartnerLogoConfig | undefined {
	if (!cdParceiroLogo) {
		return undefined;
	}

	return PARTNER_LOGO_MAP[cdParceiroLogo];
}
